
import { useState } from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import { request } from "../../config/request.ts";

interface StatusSwitchProps {
  checked: boolean;
  apiUrl: string;
  payload?: any;
  onSuccess?: () => void;
}

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export default function StatusChangeSwitch({
  checked,
  apiUrl,
  payload,
  onSuccess,
}: StatusSwitchProps) {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(checked);

  const handleChange = async (event: any) => {
    const newValue = event.target.checked;

    setValue(newValue);
    setLoading(true);

    try {
      await request.put(apiUrl, {
        ...payload,
        // status: newValue,
      });

      onSuccess?.();
    } catch (err) {
      setValue(!newValue);
    }

    setLoading(false);
  };
  return (
    <FormControlLabel
      control={
        <Android12Switch
          checked={value}
          onChange={handleChange}
          disabled={loading}
        />
      }
      label=""
    />
  );
}
